const IMAGE_FORMAT = ['.jpg', '.gif', '.jpeg', 'svg', '.png']

export const getDocumentFormat = (urlFile) => '.' + urlFile.split('.').pop()

export const isImage = (urlFile) => (
  IMAGE_FORMAT.includes(getDocumentFormat(urlFile))
)
